import { render, staticRenderFns } from "./WholeCalendarToolbar.vue?vue&type=template&id=166fea7f"
import script from "./WholeCalendarToolbar.vue?vue&type=script&lang=js"
export * from "./WholeCalendarToolbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports